/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/*
$(document).ready(function() {
  
  
  function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
    
  function checkCookie() {
    
  var username = getCookie("geolizr-dismissed-popup-2347");
  if (username != "") {
    
    
   var date = new Date();
   date.setTime(date.getTime()+(30*1000));
   var expires = "expires="+date.toGMTString();
    document.cookie = "geolizr-dismissed-popup-2347 = true; "+expires+" domain=.gymkum.myshopify.com; path=/";
  
  } 
}
  checkCookie();
  
});

*/

$(document).ready(function() {
    $(".Header__Icon").click(function(){
      
      setTimeout(
  function() 
  {
    $(".tmenu_item_level_0").removeClass("tmenu_item_active");
  }, 300);
    }); 

if($(window).width() <= 1007){
  $(window).scroll(function (event) {
    var scroll = $(window).scrollTop();
    if(scroll >= 200){
        $(".ProductForm__AddToCart").attr("style","display: block !important;background-color: rgb(255, 91, 0) !important;");
    }
});
}
  
});
